import { render } from "./AlertasDispositivo.vue?vue&type=template&id=0ac76c4b&scoped=true"
import script from "./AlertasDispositivo.vue?vue&type=script&lang=js"
export * from "./AlertasDispositivo.vue?vue&type=script&lang=js"

import "./AlertasDispositivo.vue?vue&type=style&index=0&id=0ac76c4b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ac76c4b"]])

export default __exports__